import React from 'react';
import styled from 'styled-components';

import Button from 'components/basic/Button/Button';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { KATANA_PERPS } from 'config/constants';

const Wrapper = styled.div`
  padding: 50px;
  text-align: center;
`;

/**
 * This failback page is displayed when user cannot load bundle.
 *  - it can happen after bundles are updated but user did not refreshed page
 *  - so might try to load old code-splitted pages which are no longer available
 */
export default function DynamicJsUpdateErrorPage() {
  return (
    <Wrapper>
      <MaterialSymbol icon="system_update" fontSize="large" />
      <h1>Update Available</h1>
      <p>
        A new version of {KATANA_PERPS} is available. Reload the page to get the
        latest updates.
      </p>
      <br />
      <Button inline onClick={() => window?.location?.reload()}>
        Reload now
      </Button>
    </Wrapper>
  );
}
